import React, { Suspense, useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import Loader from "./shared/Loader";
import { setIntimationRequest } from '../reducers/intimationRequest.slice';
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { dataLayerPush } from "../utils/gtm";
import { NpsIntimation } from '@mediassistrepo/homepage-component';
import { getBaseProfile } from "../reducers/baseProfile.slice";
import { FeedBack, SetNpsFeedBack } from "../api/homeAPI";
import { EntityValue, FeedbackValue, NpsFeedback } from "../common/Nps/nps.models";
import "@mediassistrepo/out-of-pocket/dist/root.css";


interface OutOfPocketProps {
    intimationId: string;
    handleHomeClick: () => void;
    npsHandleClick: (data: any) => void;
    triggerGtmEvent: (details: any) => void;
    handleIntimateInsurerClick: (details: any) => void;
  }
function OOP() {
  const dispatch = useAppDispatch();
  const OutOfPocket = React.lazy(async () => {
    const module = await import("@mediassistrepo/out-of-pocket");
    return {
      default: module.OutOfPocket as React.ComponentType<OutOfPocketProps>
    };
  });
    const search = window.location.search;
    const query = new URLSearchParams(search);
    const navigate = useNavigate();
    const intimationID = query.get('intimationID');
    const webComponentRef = useRef(null);
    const baseProfile = useAppSelector(getBaseProfile);
    const location = useLocation();
    const intimationData = location.state;

    const [name, setName] = useState('');
    const [getIntimationId, setGetIntimationId] = useState('');
    const [showNpsIntimation, setShowNpsIntimation] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [intimationCount, setIntimationCount] = useState(0);

    const priMaId = `${baseProfile?.data?.maid}`;

    const handleHomeClick = () => {
        navigate("/");
      };
      const triggerGtmEvent =(details:any)=>{
        if(details)
          dataLayerPush?.(details[0],details[1]);
      }
      const npsHandleClick =(data:any)=>{
        setName(data?.beneficiaryName);
        setGetIntimationId(data?.intimationId);
      }
      const handleIntimateInsurerClick =(details:any)=>{
        if(details){
            dispatch(setIntimationRequest(details));
            navigate("/intimation");
        }
      }


    useEffect(() => {
        if (!getIntimationId.includes("-")) {
            const timer = setTimeout(() => {
                fetchNpsIntimationApi(priMaId, 'NPS_INTIMATION');
            }, 5000);

            return () => clearTimeout(timer);
        }
    }, [getIntimationId, priMaId]);
    

    const fetchNpsIntimationApi = async (priMaId: string, entityType: string) => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        
        try {
            const feedback = await FeedBack(priMaId, entityType);
    
            if (!feedback?.data) {
                throw new Error("No data returned from the feedback API");
            }
    
            const remindLaterCount = feedback?.data?.feedback_value?.remind_later?.count || 0;
    
            if (feedback?.data?.statusCode === 204 || remindLaterCount < 3) {
                setShowNpsIntimation(true);
            } else {
                setShowNpsIntimation(false);
            }
        } catch (err) {
        } finally {
            setIsSubmitting(false);
        }
    };
    


    const remindLater = useCallback(async (
        type: string,
        setCount: React.Dispatch<React.SetStateAction<number>>,
        closePopup: () => void
    ) => {
        try {
            const response = await FeedBack(priMaId, type);
            let currentCount = response?.data?.feedback_value?.remind_later?.count || 0;

            const newCount = currentCount + 1;
            setCount(newCount);

            if (newCount > 3) {
                closePopup();
            }

            const feedbackValue: FeedbackValue = { remind_later: { count: newCount } };
            const entityValue: EntityValue = { feedback_value: feedbackValue, feedback_rating: "NA" };

            const requestObject = {
                source: 'nps_intimation',
                entity_Type: type,
                entity_Id: priMaId.toString(),
                entity_Value: entityValue,
            };

            const updateResponse = await SetNpsFeedBack(requestObject);
            if (updateResponse?.data?.isSuccess) {
                closePopup();
            } else {
            }
        } catch (err) {
        }
    }, [priMaId]);

    const intimationRemindLater = () => {
        remindLater('NPS_INTIMATION', setIntimationCount, () => setShowNpsIntimation(false));
    };

    const feedback = useCallback(async (data: { sliderValue: number; checkedStates: string[]; remarks: string }) => {
        let feedbackValue: Record<string, any> = {
        };

        if (data?.sliderValue >= 8) {
            feedbackValue["Why did you like the experience?"] = data?.checkedStates;
        } else if (data?.sliderValue > 0 && data?.sliderValue < 8) {
            feedbackValue["What did you dislike about the experience?"] = data?.checkedStates;
        }

        feedbackValue['Beneficiary name'] = name;
        feedbackValue['Primary beneficiary MA ID'] = priMaId;
        feedbackValue['Intimation ID'] = getIntimationId;
        feedbackValue['Mobile'] = `${baseProfile?.data?.mobileNo}`;
        feedbackValue['Email ID'] = `${baseProfile?.data?.emailId}`;
        feedbackValue['Do you have any suggestions for improving the claim Intimation process?'] = data?.remarks;

        const entityValue: EntityValue = {
            feedback_rating: data?.sliderValue,
            feedback_value: feedbackValue
        };

        const requestObject = {
            source: 'nps_intimation',
            entity_Type: 'NPS_INTIMATION',
            entity_Id: priMaId.toString(),
            entity_Value: entityValue,
        };

        try {
            const response = await SetNpsFeedBack(requestObject);
            if (response?.data?.isSuccess) {
                // setShowNpsIntimation(false);
            } else {
            }
        } catch (err) {
        }
    }, [name, priMaId, getIntimationId, baseProfile]);

    const goBack = () => {
        setShowNpsIntimation(false);
    }
    
    useEffect(() => {
        if (showNpsIntimation) {
        document.body.classList.add("overflow-hidden");
        } else {
        document.body.classList.remove("overflow-hidden");
        }
        return () => {
        document.body.classList.remove("overflow-hidden");
        };
    }, [showNpsIntimation]);

    return (
        <React.Fragment>
            <div style={{padding:'20px'}}>
                {!intimationID ? 
                <Loader/>
                :
                <>
                    {showNpsIntimation && (
                        <NpsIntimation
                            benefName={name}
                            intimationId={getIntimationId}
                            priBenefId={priMaId}
                            source={'nps_intimation'}
                            entity_Type={'NPS_INTIMATION'}
                            remindLater={intimationRemindLater}
                            onSubmit={feedback}
                            goBack={goBack}
                        />
                    )}
                    <Suspense fallback={<Loader />}>
                        <OutOfPocket
                            intimationId={intimationID}
                            handleHomeClick={handleHomeClick}
                            npsHandleClick={npsHandleClick}
                            triggerGtmEvent={triggerGtmEvent}
                            handleIntimateInsurerClick={handleIntimateInsurerClick}
                        />
                    </Suspense>
                </>
            }
            </div>
        </React.Fragment>
    );
}

export default OOP;
